<template>
	<b-card class="my-3">
		<b-overlay :show="loading" no-wrap></b-overlay>
		<b-card-header class="mb-5">
			<b-form-row>
				<b-form-group class="col-md-3" label="Fecha Inicio">
					<b-form-datepicker
							size="sm"
							locale="es"
							reset-button
							v-model="filters.startDate"
					/>
				</b-form-group>
				<b-form-group class="col-md-3" label="Fecha fin" >
					<b-form-datepicker
						size="sm"
						locale="es"
						reset-button
						v-model="filters.endDate"
					/>
				</b-form-group>
				<b-form-group class="col-md-2" label="Zona Origen ID">
					<b-input v-model="filters.zoneFromId" size="sm" />
				</b-form-group>
				<b-form-group class="col-md-2" label="Zona Destino ID">
					<b-input v-model="filters.zoneToId" size="sm"/>
				</b-form-group>
				<b-form-group class="col-md-2" label=".">
					<b-button variant="primary" @click="fetch" size="sm" class="text-right">Buscar</b-button>
				</b-form-group>
			</b-form-row>

		</b-card-header>
		<b-pagination
			v-model="pag.current"
			:total-rows="100000000"
			:per-page="pag.pp"
			@page-click="pageClicked"
			hide-goto-end-buttons
			limit="1"
			next-text=">>>"
			prev-text="<<<"
		></b-pagination>
		<b-table :items="changes" :fields="fields" striped hover responsive>
			<template #cell(user)="data">
			<b-badge variant="info">{{ data.item.user }}</b-badge>
			</template>
			<template #cell(change)="data">
			{{ data.item.change }}
			</template>
			<template #cell(_zones)="data">

				<p class="zoneLabel m-0" style="text-align: left; padding: 0;"><small>{{ data.item.zoneFrom.title}}</small></p>
				<p class="zoneLabel m-0" style="text-align: center; padding: 0;"><md-icon icon="trending_flat airport_shuttle trending_flat" /></p>
				<p class="zoneLabel m-0" style="text-align: right; padding: 0;"><small>{{ data.item.zoneTo.title}}</small></p>

			</template>
			<template #cell(changes)="data">
				<span v-for="(change, i) in data.item.changes" :key="`${i}`">{{change}}<br/></span>
			</template>


		</b-table>

	</b-card>
</template>

<script>
export default {
	name: 'ResourceChanges',
	props: {
		ratePlanId: {
			type : Number,
			required: true,
		},
	},
	data() {
		return {
			loading:false,
			fields: [
				{ key: 'id', label: '#' },
				{ key: 'user', label: 'Email' },
				{ key: 'creationDatetime', label: 'Cuando?' },
				{ key: 'type', label: 'Nivel' },
				{ key: '_zones', label: 'Zones' },
				{ key: 'changes', label: 'Cambios' }
			],
			changes: [],
			pag:{
				current:1,
				pp:10
			},
			filters:{
				startDate:null,
				endDate:null,
				zoneToId:null,
				zoneFromId:null
			}
		};
	},
	methods: {
		fetch() {
			this.loading = true;
			let offset = (this.pag.current==1)?0: (this.pag.current*this.pag.pp)
			this.$root.api
			.get(`/rate-plans/${this.ratePlanId}/logs`,{params: {filters:this.filters,offset:offset,limit:this.pag.pp}})
			.then(res => {
				this.changes = res.data;
				console.log(res)
			})
			.catch(this.$root.handleRequestError)
			.finally(()=>{
				this.loading = false
			})
		},
		pageClicked(){
			setTimeout(()=>{
				this.fetch()
			},0)
		}
	},
	mounted() {
		this.fetch();
	},
};
</script>

<style scoped>
.my-3 {
	margin-top: 1rem;
	margin-bottom: 1rem;
}
.text-muted {
	text-align: right;
}
</style>
